(function() {
    "use strict";

    const ko = require('knockout');
    const $ = require('jquery');

    class MembersViewModel {
        constructor() {
            this.members = ko.observableArray([]);
        }

        load() {
            $.ajax('/api/search/members', {
                method: 'get',
                success: data => {
                    this.members(data);
                }
            });
        }
    }

    module.exports = MembersViewModel;
})();


// WEBPACK FOOTER //
// ./resources/scripts/viewmodels/membersViewModel.js